import React, { useState, useEffect } from "react";
import { COLORS } from "../../Constants/AppColors.js";
import { useTranslation } from "react-i18next";
import "../../Translation/i18n";
import i18n from "i18next";
// import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Aos from "aos";
import "aos/dist/aos.css";
import APIs from "../../network/APIs.js";
import "./style.css";

function BoardMembersPage() {
  const { t } = useTranslation();

  const [innerWidthState, setInnerWidthState] = useState(window.innerWidth);
  const [innerHeightState, setInnerHeightState] = useState(window.innerHeight);
  const [directionState, setDirectionState] = useState("ltr");

  const [requestResponseState, setRequestResponseState] = useState([]);

  

  React.useEffect(() => {
    Aos.init();

    const getShareholders = () => {
      if (requestResponseState.length === 0)
        APIs.instance.getBoardMember().then(([statusCode, data]) => {
          if (statusCode === 200) {
            setRequestResponseState(data.results);
          }
        });
    };
  
    getShareholders();

    if (i18n.language.includes("en")) {
      setDirectionState("ltr");
    } else {
      setDirectionState("rtl");
    }

    function handleResize() {
      console.log("resized to: ", window.innerWidth, "x", window.innerHeight);
      setInnerWidthState(window.innerWidth);
      setInnerHeightState(window.innerHeight);
    }

    window.addEventListener("resize", handleResize);

    console.log("i18n.locale: " + i18n.language);
  },  []);

  const listItems = requestResponseState.map((item) => (
    <div
      data-aos="fade-zoom-out"
      data-aos-offset="100"
      class="col-11 col-md-6 col-lg-3 mx-0 mb-4"
    >
      <div
        class="card p-0 overflow-hidden h-100 shadow "
        style={{ borderRadius: 20 }}
      >
        <img
          src={
            item.image.includes("Itamco")
              ? i18n.language.includes("en")
                ? require("../../assets/Itamco_EN.png")
                : require("../../assets/Itamco_AR.png")
              : item.image
          }
          class="thumbnail img-responsive img-fluid mx-auto"
          style={{
            height: 220,
            // padding: 5,
            borderColor: "#00000001",
          }}
          alt=""
        />
        <div class="card-body" style={{ backgroundColor: "#EAEEF6" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <label
              style={{
                color: "#0047BA",
                marginTop: -10,
                fontSize: 20,
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Subtitle"
                  : "CI-Font-Subtitle-ar",
              }}
            >
              {i18n.language.includes("en") ? item.name_en : item.name_ar}
            </label>
            <label
              style={{
                color: "#898D90",
                marginTop: 10,
                fontSize: 14,
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Body-Text"
                  : "CI-Font-Body-Text-ar",
              }}
            >
              {i18n.language.includes("en")
                ? item.position_en
                : item.position_ar}
            </label>
          </div>
        </div>
      </div>
    </div>
  ));

  return (
    <div
      dir={directionState}
      style={{
        backgroundColor: "#F7F8F9",
        backgroundSize: "cover",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <label
          style={{
            color: COLORS.PageTitleFirstColor,
            marginTop: 20,
            marginBottom: -20,
            fontSize: 35,
            textAlign: i18n.language.includes("en") ? "left" : "right",
            fontFamily: i18n.language.includes("en")
              ? "CI-Font-Title"
              : "CI-Font-Title-ar",
          }}
        >
          {t("board_member_pt1")}{" "}
          <label
            style={{
              color: COLORS.PageTitleSecondColor,
              marginTop: 20,
              marginBottom: -20,
              fontSize: 35,
              textAlign: i18n.language.includes("en") ? "left" : "right",
              fontFamily: i18n.language.includes("en")
                ? "CI-Font-Title"
                : "CI-Font-Title-ar",
            }}
          >
            {t("board_member_pt2")}{" "}
          </label>
        </label>
        <section className="py-4 py-lg-5 container">
          {requestResponseState.length === 0 ? null : (
            <div className="row">{listItems}</div>
          )}
        </section>
      </div>
    </div>
  );
}

export default BoardMembersPage;
